import type { BlockComponentProps } from "./shared"

export function ButtonBlock({ content, resolved }: BlockComponentProps) {
  const btText = (content?.text as string) ?? ""
  const btUrl = (content?.url as string) ?? ""
  const btVariant = (content?.variant as "primary" | "secondary" | "outline") ?? "primary"
  const btAlign = (content?.align as "left" | "center" | "right") ?? "left"
  const primaryColor = "var(--nos-color-primary, #3b82f6)"
  if (!btText) return null
  const alignClass = { left: "text-left", center: "text-center", right: "text-right" }[btAlign]
  const btnClass =
    btVariant === "primary"
      ? "hover:opacity-90"
      : btVariant === "secondary"
        ? "bg-muted text-foreground hover:bg-muted/80"
        : "border border-muted-foreground/50 hover:bg-muted/50"
  // Primary buttons follow the Brand Panel button feel (solid | outline | pill).
  const primaryStyle: React.CSSProperties = {
    backgroundColor: `var(--nos-button-bg, ${primaryColor})`,
    color: "var(--nos-button-color, #ffffff)",
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "var(--nos-button-border-color, transparent)",
    borderRadius: "var(--nos-button-radius, 8px)",
  }
  const btn = (
    btUrl ? (
      <a
        href={btUrl}
        className={`inline-block px-6 py-3 rounded-lg font-semibold transition-opacity ${btnClass}`}
        style={btVariant === "primary" ? primaryStyle : undefined}
      >
        {btText}
      </a>
    ) : (
      <button
        type="button"
        className={`px-6 py-3 rounded-lg font-semibold ${btnClass}`}
        style={btVariant === "primary" ? primaryStyle : undefined}
      >
        {btText}
      </button>
    )
  )
  const btSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-4"} ${resolved.cornerClass} ${resolved.alignClass || alignClass}`.trim()
    : `px-4 py-4 @sm:px-6 @md:px-8 ${alignClass}`
  return (
    <section className={btSectionClass} style={resolved.sectionStyle}>
      {btn}
    </section>
  )
}
